// Libraries
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

// Api
import contractsApi from '../api/contractsApi';

// Core
import { ResourceTextApplication } from '../core/resources';

// Feature
import { IContractListItem } from '../interfaces/IContract';
import { IFarmDetails } from '../interfaces/IBusinessEntities';
import ViewLoader from '../common/ViewLoader';
import ContractListView from './components/list/ContractListView';

export default function FarmContracts(props: { farm: IFarmDetails | null, loading: boolean, producerView?: boolean | undefined }) {
    const { farm, producerView } = props;
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral', 'AnelmaContract']);
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState<boolean>(true);
    const [contracts, setContracts] = useState<IContractListItem[]>([]);

    useEffect(() => {
        if (farm) {
            setLoading(true);
            getContracts(farm).then(() => {
                setLoading(false);
            });
        }
    }, [farm])

    const getContracts = async (farm: IFarmDetails) => {
        let contracts = await contractsApi.getFarmContracts(farm.Id ?? '', farm.Names[0].Value);

        if (!contracts) {
            enqueueSnackbar(t('AnelmaGeneral:1020'), {
                variant: 'error',
            });
        }
        else if (contracts.Items !== null)
            setContracts(contracts.Items);
        else
            setContracts([]);
    }

    return loading || props.loading || !farm
        ? <ViewLoader />
        : <ContractListView
            farm={farm}
            contracts={contracts}
            getContracts={getContracts}
            producerView={producerView}
        />;
}
